import {Injectable} from '@angular/core';
import {Headers, Http, RequestOptions, Response} from '@angular/http';
import {Observable} from 'rxjs/Observable';

import {Company} from 'classes/company';
import {User} from 'classes/user';
import {UserRole} from 'classes/user-role';
import {environment} from 'environment';
import { Content } from 'shared/models/contents/content';
import { Badge } from 'shared/models/badges/badge';
import { TargetGroup } from 'shared/models/target-groups/target-group';
import { Group } from 'shared/models/target-groups/group';
import { Category } from 'shared/models/target-groups/category';

@Injectable()
export class UserDetailsRepository {

  constructor(private http: Http) { }

  public getUser(id: number): Observable<User> {
    const options: RequestOptions = new RequestOptions({
      withCredentials: true,
    });

    return this.http.get(`${environment.users}/${id}`, options)
      .map((res: Response) => res.json())
      .map((rawUser: User) => User.create(rawUser));
  }

  public getAllCompanies(): Observable<Array<Company>> {
    const options: RequestOptions = new RequestOptions({
      withCredentials: true,
    });

    return this.http.get(`${environment.targetGroups.companies}`, options)
      .map((response: Response) => {
        return response.json();
      });
  }

  public getAllContents(): Observable<Array<Content>> {
    const options: RequestOptions = new RequestOptions({withCredentials: true});

    return this.http.get(environment.contents, options)
      .map((response: Response) => {
        return response.json();
      });
  }

  public getAllBadges(): Observable<Array<Badge>> {
    const options: RequestOptions = new RequestOptions({withCredentials: true});

    return this.http.get(environment.badges, options)
      .map((response: Response) => {
        return response.json();
      });
  }

  public getAllTargetGroups(): Observable<Array<TargetGroup>> {
    const options: RequestOptions = new RequestOptions({withCredentials: true});

    return this.http.get(`${environment.targetGroups.targetGroups}`, options)
      .map((response: Response) => {
        return response.json();
      });
  }

  public getAllGroups(): Observable<Array<Group>> {
    const options: RequestOptions = new RequestOptions({withCredentials: true});

    return this.http.get(`${environment.targetGroups.groups}`, options)
      .map((response: Response) => {
        return response.json();
      });
  }

  public getAllCategories(): Observable<Array<Category>> {
    const options: RequestOptions = new RequestOptions({withCredentials: true});

    return this.http.get(`${environment.targetGroups.categories}`, options)
      .map((response: Response) => {
        return response.json();
      });
  }


  public saveUser(user: User): Observable<User> {
    const headers: Headers = new Headers({
      'Content-Type': 'application/json',
    });

    const options: RequestOptions = new RequestOptions({
      withCredentials: true,
      headers: headers,
    });

    const body: string = JSON.stringify(this.prepareUserForBackend(user));

    return this.http.post(environment.users, body, options)
      .map((res: Response) => {
        return res.json();
      })
      .map((rawUser: User) => {
        return User.create(rawUser);
      });
  }

  public updateUser(user: User): Observable<User> {
    const headers: Headers = new Headers({
      'Content-Type': 'application/json',
    });

    const options: RequestOptions = new RequestOptions({
      withCredentials: true,
      headers: headers,
    });

    const body: string = JSON.stringify(this.prepareUserForBackend(user));

    return this.http.put(`${environment.users}/${user._id}`, body, options)
      .map((res: Response) => {
        return res.json();
      })
      .map((rawUser: User) => {
        return User.create(rawUser);
      });
  }

  public getUserRoles(): Observable<Array<UserRole>> {
    const options: RequestOptions = new RequestOptions({
      withCredentials: true,
    });

    return this.http.get(`${environment.users}/roles`, options)
      .map((res: Response) => {
        return res.json();
      });
  }

  public deleteUnstartedContents(user: User): Observable<boolean> {
    const headers: Headers = new Headers({
      'Content-Type': 'application/json',
    });

    const options: RequestOptions = new RequestOptions({
      withCredentials: true,
      headers: headers,
    });

    const body: string = JSON.stringify({userId: user._id});

    return this.http.put(`${environment.users}/deleteUnstartedContents/${user._id}`, body, options)
      .map((res: Response) => {
        return res.json();
      });
  }

  public modifyContents(user: User, modContent: Array<any>): Observable<boolean> {
    const headers: Headers = new Headers({
      'Content-Type': 'application/json',
    });

    const options: RequestOptions = new RequestOptions({
      withCredentials: true,
      headers: headers,
    });

    const body: string = JSON.stringify(modContent);

    return this.http.put(`${environment.users}/modifyContents/${user._id}`, body, options)
      .map((res: Response) => {
        return res.json();
      });
  }

  private prepareUserForBackend(user: User): any { // tslint:disable-line:no-any
    const newUser: any = { // tslint:disable-line:no-any
      email: user.email,
      firstname: user.firstname,
      lastname: user.lastname,
      active: user.active,
      password: user.password,
      company: user.company._id,
      roles: this.getRoleIds(user.roles),
      groups: user.groups,
      categories: user.categories,
    };

    return newUser;
  }

  private getRoleIds(roles: Array<UserRole>): Array<number> {
    return roles.map((role) => {
      return role._id;
    });
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/user/user-details/repositories/user-details.repository.ts